import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

import Constants from '../Constants';
import { useNavigate } from 'react-router-dom';

import '../App.css';

import wordmark from '../assets/menu-wordmark.png';

function VerificationEmailSent() {
	const [userEmail, setUserEmail] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		const email = localStorage.getItem(Constants.SIGNUP_USER_EMAIL);
		if(email) {
			setUserEmail(email);
		}
	}, []);

	const handle_on_click = ()=>{
		navigate('/login');
	}

	const renderMainContent = ()=>{

		const email_verified_copy = "A verification email has been sent to ";

		return(
			<div className="text-center email-verification-card">
				<p className='email-verification-text'>
						{email_verified_copy}
						<span className='email-verification-email'>
							{userEmail}
						</span>.
				</p>
				<p className='email-verification-text'>
					Please check your inbox and click the verification link to activate your account.
				</p>
			</div>
		);
	}

	return (
		<Container fluid className='auth-container'>
		<Row className='auth-row'>
			<Col lg={4} md={6} sm={10} xs={11}>
			<Card className='auth-card'>
				<Card.Body className='auth-card-body'>
				
					<Row>
					<img src={wordmark} className="signin-logo"/>
					<h3 className='auth-title'>Verification Email Sent</h3>
					</Row>
					<Row>
						{renderMainContent()}
					</Row>

					<Row>
						<Button variant="primary" onClick={handle_on_click} >Ok</Button>
					</Row>

				</Card.Body>
			</Card>
			</Col>
		</Row>
		</Container>
	);

}

export default VerificationEmailSent;
